<div *ngIf="isLoading">
  <app-spinner></app-spinner>
</div>
<div>
  <router-outlet></router-outlet>
</div>
<app-compare-navbar></app-compare-navbar>